export default {
  horizontal: {
    paddingLeft: 0,
    paddingRight: 0
  }
};
